
import {
    defineComponent,
    inject,
    watch,
    ref
} from "vue";

//services
import personSer from "@/core/services/PersonService";
import {
    errManager
} from "@/core/config/Tools";
import {
    useI18n
} from "vue-i18n/index";

//components
import sPerson from "@/components/wizard/steps/sPerson.vue";
import PhotoManager from "./photo/PhotoManager.vue"
import TableHistory from "@/views/persons/history/TableHistoty.vue"
import Sanctions from "./sanctions/List.vue"

export default defineComponent({
    components: {
        sPerson,
        PhotoManager,
        TableHistory,
        Sanctions
    },
    setup(props) {
        const {
            t
        } = useI18n();
        const url = ref(process.env.VUE_APP_REPO);
        const activeOption = ref("profile");
        const gblPersona = inject<any>('gblPersona')

        const menuOptions = ref([{
                value: "0",
                label: 'Perfil',
                icon: 'bi bi-person-vcard fs-2 mx-2'
            },
            {
                value: "1",
                label: 'Historial',
                icon: 'bi bi-clipboard-data fs-2 mx-2'
            },
            {
                value: "2",
                label: 'Destacado',
                icon: 'bi bi-trophy fs-2 mx-2'
            },
            {
                value: "3",
                label: 'Sanciones',
                icon: 'bi bi-sign-stop fs-2 mx-2'
            },
            {
                value: "4",
                label: 'Accesorios',
                icon: 'bi bi-chat-square-text fs-2 mx-2'
            },
            {
                value: "5",
                label: 'Academico',
                icon: 'bi bi-briefcase fs-2 mx-2'
            },
        ])

        //variables compatidas
        const gblPhoto = inject < any > ('gblPhoto')
        const dialog_details = inject("dialog_details");
        

        const loaderPhoto = ref(false);
        const photo = ref( < any > {});

        const getPhoto = async () => {
            loaderPhoto.value = true;
            photo.value = {};
            await personSer
                .getPhoto({
                    idperson: gblPersona.value.idperson,
                })
                .then((res) => {
                    photo.value = res.data;
                    loaderPhoto.value = false;
                })
                .catch(({
                    response
                }) => {
                    loaderPhoto.value = false;
                    errManager(response, null, 2);
                });
        };

        watch(() => gblPhoto.value, getPhoto);

        const onOpened = () => {
            activeOption.value = "profile";
            getPhoto();
        };

        const onClosed = () => {
            activeOption.value = "xxx";
            photo.value = {};
        };

        return {
            t,
            url,
            dialog_details,
            menuOptions,
            activeOption,
            gblPersona,

            loaderPhoto,
            photo,
            getPhoto,
            gblPhoto,

            //events
            onOpened,
            onClosed,
        };
    },
});
